<template>
  <shop-list
    :title="title"
    :type="type"
  ></shop-list>
</template>

<script>
import ShopList from '@/components/ShopList'
import MetaInfoBuilder from '@/utils/social'

export default {
  components: {
    ShopList,
  },
  data: () => ({
    title: 'E-Books',
    type: 'ebooks',
  }),
  metaInfo() {
    return new MetaInfoBuilder()
      .description(this.title)
      .title(this.title)
      .build()
  }
}
</script>
